import { render, staticRenderFns } from "./customize-order.vue?vue&type=template&id=2fa9b590&scoped=true"
import script from "./customize-order.vue?vue&type=script&lang=js"
export * from "./customize-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa9b590",
  null
  
)

export default component.exports